import { EventTranslation } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<EventTranslation>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminEventTranslationsReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminEventTranslation.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getAdminEventTranslation.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getAdminEventTranslation.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getAdminEventTranslation.reset.type]: actionsHandlers.handleGetOneReset,
  [actions.updateAdminEventTranslation.request.type]: actionsHandlers.handleUpdateOneRequest,
  [actions.updateAdminEventTranslation.success.type]: actionsHandlers.handleUpdateOneSuccess,
  [actions.updateAdminEventTranslation.failure.type]: actionsHandlers.handleUpdateOneFailure,
  [actions.updateAdminEventTranslation.reset.type]: actionsHandlers.handleUpdateOneReset,
});

export default adminEventTranslationsReducer;
